import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    renderSettingsCTA: string;
    noComposition: string;
    renderAndUpload: string;
    compositions: string;
    queued: string;
    emptyRenderQueue: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** CTA to choose export settings in Render Queue */
            renderSettingsCTA: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.renderSettingsCTA?c=39amh7md7ont3", defaultMessage: "Output settings are managed in the Render Queue panel." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Form validation error message when no active composition is present */
            noComposition: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.noComposition?c=1fvl5wk859mu1", defaultMessage: "No active composition" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to start the export process (Render + Upload) */
            renderAndUpload: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.renderAndUpload?c=2xflyammmfz9r", defaultMessage: "Render & Upload" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the number of compositions */
            compositions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.compositions?c=fmvx92p7a91d", defaultMessage: "Compositions" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the number of compositions queued for export */
            queued: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.queued?c=1itlm2jfolb2b", defaultMessage: "Queued" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message shown when the render queue is empty */
            emptyRenderQueue: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompositionExportAll.emptyRenderQueue?c=1nrz2kpsjxo2q", defaultMessage: "No items in the render queue" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
